
import { VTooltip } from "vuetify/lib";

export default VTooltip.extend({});
